import { Component, computed, input, signal } from '@angular/core';
import { ChartData, ChartDataset, ChartOptions } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { groupBy } from '../../utils/array';
import { TranslationService } from '../../woo_services.module/TranslationService';
import { CampaignFrequencyReport } from '../services/campaign-frequency-report.service';

@Component({
  selector: 'frequency-limit-per-month-graph',
  imports: [BaseChartDirective],
  template: `
    <div class="chart-wrapper">
      <canvas baseChart [data]="lineChartData()" [options]="lineChartOptions()" [type]="'bar'"></canvas>
    </div>
  `,
})
export class FrequencyLimitPerMonthGraph {
  readonly reports = input<CampaignFrequencyReport[]>([]);

  lineChartOptions = signal<ChartOptions<'line'>>({
    responsive: true,
    hover: { mode: 'nearest', intersect: true },
    plugins: { legend: { display: true, position: 'top' } },
    scales: { y: { beginAtZero: true } },
  });

  readonly lineChartData = computed<ChartData<'line'>>(() => {
    const reports = this.reports();
    if (!reports?.length) {
      return { labels: [], datasets: [] };
    }

    const labels = Array(12)
      .fill(null)
      .map((_, idx) => this.translationService.convertMonthIndex(idx).full);

    const datasets = this.getData(reports);

    return { labels, datasets };
  });

  constructor(private translationService: TranslationService) {}

  private getData(reports: CampaignFrequencyReport[]): ChartDataset<'line'>[] {
    const nullIfAllZero = (list: number[]) => (list.every((i) => i === 0) ? null : list);

    return Array.from(groupBy(reports, (r) => r.year).entries())
      .flatMap(([year, reports]) => [
        {
          label: `${year} adserver`,
          data: nullIfAllZero(reports.map((r) => r.average_adserver_frequency)),
          fill: false,
        },
        {
          label: `${year} mms`,
          data: nullIfAllZero(reports.map((r) => r.average_mms_frequency)),
          fill: false,
        },
      ])
      .filter((set) => set.data !== null) as ChartDataset<'line'>[];
  }
}
